import { ENV_NAME } from "@gc-npm/utils.enums.environment";

export const FRACTIONALLIMITPRICES = 0;
export const FRACTIONALQUOTAMONTHS = 6;

export const SAVING_LIMIT_PRICE = 9;
export const SAVING_LIMIT_PRICE_TO_LINE_THROUGH = 0;

export const PRODUCT_CATEGORY = {
  SMARTPHONES: 'smartphone',
  SMARTWATCHES: 'smartwatch',
  TABLETS: 'tablet',
  TVS: 'tv',
  BUNDLES: 'pack',
  PREOWNED: 'preowned',
  EQUIPMENT: 'equipment',
  LAPTOPS: 'laptop',
  ACCESSORIES: 'accesory',
  GAMING: 'gaming',
  EXERCISE: 'exercise',
  HOME: 'home',
  SENIORS: 'seniorphone',
  ACTIVITYBRACELET: 'activitybracelet',
  CONSOLES: 'videoconsole',
  ALL: 'all',
};

/* URL PROCESO COMPRA */
export const SETH_LOGIN_REDIRECT = 'https://www.movistar.es/auth/login?redirect=';
export const URLSPURCHASEPROCESS = {
  processVTL: 'https://www.movistar.es/order/telco/dispositivos/',
  processR2R: 'https://www.movistar.es/order/telco/gp/r2r/',
  processSecondaryIncludedR2R: 'https://www.movistar.es/order/telco/gp/r2r-2/',
  processPackR2R: 'https://www.movistar.es/order/telco/gp/pack-r2r/',
  processRenewR2RManual: 'https://www.movistar.es/order/telco/gp/renovacion-r2r/',
  processRenewR2RSemiautomatic: 'https://www.movistar.es/order/telco/gp/autorenovacion-r2r/'
}

export const BUYPROCESS_URL_KEY_PARAMS = {
  pid: 'pid',
  productOffering: 'productOffering',
  productSpecStorage: 'idCapacidadTelco',
  productSpecColor: 'idColorTelco',
  secondaryR2Rs: 'secondaryR2Rs',
  modality: 'modalidad',
  canBeFounded: 'solicitarFinanciacion',
  option: 'opt',
  sellingChannel: 'canalVenta',
  alias: 'alias',
  months: 'months',
  segment: 'segment',
  buyProcess: 'buyProcess',
  vval: 'vval',
}

export const OPERATIONTYPE = {
  vtl: 'VTL',
  r2r: 'R2R',
  plazos: 'PLAZOS',
  tarjeta: 'TARJETA',
  fraccionado: 'FRACCIONADO',
}

export const BUYPROCESS_URL_PARAM_SELLINGCHANNEL = {
  app: 'appM',
}
export const BUYPROCESS_SESSION_KEY_PARAMS = {
  price: 'vValue',
  quota: 'vQuota',
  precompra: 'precompra',
  fecha_precompra: 'fecha_precompra',
}
export const BUYPROCESS_URL_PARAM_CANBEFOUNDED = {
  able: 'si',
  notAble: 'no',
}

export const BUYPROCESS_URL_PARAM_MODALITY = {
  particulares: '',
  empresas: '',
  empleados: 'tx',
  app: '',
  autonomos: '',
}

export const BUYPROCESS_URL_PARAM_PID = {
  meInteresaLibre: 'clic-boton-meinteresa-libre',
  meInteresaFinanciado: 'clic-boton-meinteresa-financiado',
  meInteresaLoQuiero: 'PA-ficha-movil-loquiero-',
  meInteresaFraccionado: 'clic-boton-meinteresa-fraccionado',
}

export const QUERY_PARAMS_TO_KEEP = ["segment", "offerCategory"];

/* NINJA (paso4): pendiente de valor real hasta que exista catalogacion NINJA (P-02, SA-05).
   Sin uso hoy: el acotado en origen de las llamadas SSR de paso4 (getStaticProps y
   getStaticPaths) usa NINJA_TAGS_URL_FILTERS, construido a partir del enum de abajo. */
export const NINJA_TAG = '';

/* NINJA por categoria Fusion (paso4 v14): tags a nivel de OFERTA (offer.tags, ya presente
   en las ofertas r2r crudas del catalogo, Forma B/getAllItem, ver constants/mock-json/get-all/
   mock_new_getall.json) que marcan que oferta ninja es elegible para cada categoria Fusion
   real del cliente (state.getMyProducts.categoryFusionInfo: 'av'|'mv'|'bv', ver
   utils/normalizers/get-my-products/index.js). Se usan para filtrar, en CLIENTE (runtime,
   dentro de containers/device-detail-paso4/cross-selling-paso4/), que colores/cards del
   cross-selling ve cada cliente segun su categoria real (ver
   utils/normalizers/detailed-product/cross-selling-paso4/index.js,
   filterCrossSellingProductsByFusionCategory). Distintos del NINJA_TAG generico de arriba:
   ese filtra la llamada SSR a getAllItem en getStaticProps (mismo resultado para todos los
   visitantes); estos filtran el resultado ya normalizado, por cliente, porque
   categoryFusionInfo solo se conoce en cliente tras resolver getMyProducts. */
export const NINJA_TAG_BY_FUSION_CATEGORY = {
  av: 'NINJA_AV',
  mv: 'NINJA_MV',
  bv: 'NINJA_BV',
};

/* Querystring de tags NINJA para las llamadas SSR de paso4 (getStaticProps y getStaticPaths,
   ambas en pages/[id]/[dispositivo]/paso4.js): "tags=NINJA_AV&tags=NINJA_MV&tags=NINJA_BV".
   Se piden las TRES variantes porque ambas llamadas son compartidas por todos los visitantes
   (build/ISR) y categoryFusionInfo real de cada cliente solo se conoce en cliente; el
   filtrado fino por la categoria REAL ocurre despues, via
   filterCrossSellingProductsByFusionCategory. Derivado del enum de arriba para no
   hardcodear los literales. */
export const NINJA_TAGS_URL_FILTERS = Object.values(NINJA_TAG_BY_FUSION_CATEGORY)
  .map((ninjaTag) => `tags=${ninjaTag}`)
  .join('&');